<template>
  <div class="footer">
    <p>Copyright © 2010-2015 sqgj.gov.cn, All Rights Reserved</p>
    <p>陕西干部网络学院陕ICP备10001194号-6</p>
    <div class="w-1200 d-flex j-end">
      <div>
        <img src="@/assets/img/code.png" alt="">
        <p style="color: #fff;font-size: 16px;">官方微博</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.footer{
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 30px 0 20px;
  background: #871f23;
  p{
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #999999;
  }
}
</style>
